module.exports = __webpack_public_path__ + "files/logo.5d1dbb5825625206aed3382104e98f0b.png";